import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {Box, ClickAwayListener, Link, Stack, Tooltip, Typography} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {buildContactFormUrl} from '../../../../utility/contactFormUrlUtil';

// Maria, 17 October 2026: the 'Important Information for Parents' message is shown only on the sections a parent can
// view but not edit ('View' in Manage Access), as a pop-up from a small 'View only' label, not above every tab.
const ReadOnlyNotice = () => {
    const [open, setOpen] = useState(false);
    const account = useSelector(state => state.application.account);
    const {selectedProfile, currentSchool} = useSelector(state => state.profilesInfo);
    const schoolName = currentSchool?.name || 'the school';

    const contactFormUrl = buildContactFormUrl({
        schoolName: currentSchool?.name || '',
        studentFirstName: selectedProfile?.name || '',
        studentLastName: selectedProfile?.surname || '',
        userFirstName: account?.firstName || '',
        userLastName: account?.lastName || '',
        userEmail: account?.email || '',
        pleaseChoose: 'I need to make a change to the information on my child\'s Admicity profile but I am unable to edit it OR I have a question relating to a form or email I have received',
    });

    const message = (
        <Box sx={{p: 0.5}} data-testid="read-only-notice-text">
            <Typography variant="body2" fontWeight={700} sx={{mb: 0.5}}>Important Information for Parents:</Typography>
            <Typography variant="body2">
                This section is displayed in read-only mode, which means you cannot directly edit the information. However,
                you are still required to review and confirm that the information is correct. If you notice any missing
                information or incorrect data, please contact {schoolName} to have it corrected{' '}
                <Link href={contactFormUrl} target="_blank" rel="noopener noreferrer" underline="always">using this form</Link>.
            </Typography>
        </Box>
    );

    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Box sx={{mb: 1}}>
                <Tooltip
                    title={message}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    placement="bottom-start"
                    componentsProps={{tooltip: {sx: {bgcolor: '#fff', color: 'text.primary', border: '1px solid #cfe0f5', boxShadow: 3, maxWidth: 460, p: 1.5}}}}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={0.75}
                        role="button"
                        tabIndex={0}
                        data-testid="read-only-notice"
                        onClick={() => setOpen(true)}
                        sx={{display: 'inline-flex', cursor: 'pointer', px: 1.25, py: 0.5, borderRadius: 5, backgroundColor: '#e8f1fb', color: '#186BBE'}}
                    >
                        <LockOutlinedIcon sx={{fontSize: 18}}/>
                        <Typography variant="body2" fontWeight={600}>View only</Typography>
                    </Stack>
                </Tooltip>
            </Box>
        </ClickAwayListener>
    );
};

export default ReadOnlyNotice;
